// extracted by mini-css-extract-plugin
export default {"Dialog":"ControlsDialog-module__Dialog--T6258"};